<div tabindex="=0" #multiSelectDrop (blur)="onTouched()" class="multiselect-dropdown" (clickOutside)="closeDropdown()">
  <div [class.disabled]="disabled">
    <span tabindex="-1" class="dropdown-btn" (click)="toggleDropdown($event)">
      <span class="placeholder-span" *ngIf="selectedItems.length == 0">{{_placeholder}}</span>
      <span [ngStyle]="{ display: selectedItems.length > 1 ? 'flex' : 'contents' }">
        <span class="selected-item" *ngFor="let item of selectedItems;trackBy: trackByFn;let k = index" [hidden]="k > (_settings.itemsShowLimit ? _settings.itemsShowLimit : 0)-1">
        {{item.text}}
          <a style="padding-top:2px;padding-left:2px;color:white" (click)="onItemClick($event,item)">x</a>
        </span>
      </span>
      <span style="float:right !important;padding-right:4px">
        <span style="padding-right: 6px;" *ngIf="itemShowRemaining()>0">+{{itemShowRemaining()}}</span>
        <span [ngClass]="_settings.defaultOpen ? 'dropdown-up' : 'dropdown-down'"></span>
      </span>
    </span>
  </div>
  <div class="dropdown-list"  [style.width]="defaultItemDropWidth"  [ngStyle]="{  position: defaultSettings.matchItemDropWidthToControl?'fixed':'absolute' }" [hidden]="!_settings.defaultOpen" [style.maxHeight]="((_settings.maxHeight ? _settings.maxHeight : 0)+ 50 )+'px'">
    <ul class="item1">
      <li (click)="toggleSelectAll()" *ngIf="_data.length > 0 && !_settings.singleSelection && _settings.enableCheckAll && _settings.limitSelection===-1" class="multiselect-item-checkbox part-1" style="border-bottom: 1px solid #ccc;padding:10px">
        <input type="checkbox" aria-label="multiselect-select-all" [checked]="isAllItemsSelected()" [disabled]="disabled || isLimitSelectionReached()" />
        <div>{{!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText}}</div>
      </li>
      <li class="filter-textbox" *ngIf="_data.length>0 && _settings.allowSearchFilter">
        <input type="text" aria-label="multiselect-search" [readOnly]="disabled" [placeholder]="_settings.searchPlaceholderText"
               [(ngModel)]="filter.text" (ngModelChange)="onFilterTextChange($event)"
        [autofocus]="_settings.defaultOpen" (keyup)="onEnterPress($event)">
      </li>
    </ul>
    <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
      <!-- <ng-container *ngFor="let item of _data | ng2ListFilter:filter:_settings.allowWildFilter; let i = index;"> -->
      <ng-container
        *ngFor="
          let item of (
            _settings.allowAdvancedWildcardSearch
              ? _data
              : (_data | ng2ListFilter: filter : _settings.allowWildFilter)
          );
          let i = index;
        "
      >
        <ng-container *ngIf="item?.class == MS_ITEM_SEPERATOR_CLASS; else TMPL_default">
          <li class="ms_seperator"></li>
        </ng-container>
        <ng-template #TMPL_default>
          <li  (click)="onItemClick($event,item)" class="multiselect-item-checkbox part-2"
               [ngClass]="{'selected-li': isSelected(item)}">
            <ng-container *ngIf="item?.class"><i class="{{item?.class}}" style="margin-right: 10px"></i></ng-container>
            <input type="checkbox" aria-label="multiselect-item" [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item))" />
            <div style="display: inline-block" class="item-label">{{item.text}}</div>
          </li>
        </ng-template>
      </ng-container>

      <li class='no-data' *ngIf="_data.length == 0">
        <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
      </li>
    </ul>
  </div>
</div>
